import {NibThrive} from '@nib-components/logo';
import {HeaderConfigType, GetConfigParams} from './types';
import {getBaseUrl, getLogoUrl} from './utils';
import getArhiConfig from './arhi';

const LOGO_URL = '/thrive';
const ABSOLUTE_BASEURL = 'https://www.nib.com.au';

const getThriveConfig = (config: GetConfigParams): HeaderConfigType => {
  const arhiConfig = getArhiConfig(config);
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  const logoUrl = getLogoUrl(config, baseUrl, LOGO_URL);

  return {
    ...arhiConfig,
    id: 'header-thrive',
    logoUrl: logoUrl,
    logoComponent: NibThrive,
    smallHeaderConfig: {
      ...arhiConfig.smallHeaderConfig,
      id: 'small-header-thrive',
      logoUrl: logoUrl
    }
  };
};

export default getThriveConfig;
